import {
  HomePage,
  FoodDetail,
  Notification,
  PromotionPage,
  PromocodePage,
  ProfilePage,
  AddressesPage,
  AboutPage,
  UserInfoPage,
  BasketPage,
  CheckoutPage,
  RestaurantPage,
  PickupSearch,
  PickupMap,
  OrderDetailsPage,
  OrdersPage,
  SearchPage,
  CardPage,
  SettingsPage,
} from '@/modules';
import AddingAddress from '../modules/addresses/ui/action/AddingAddress';
import EditAddress from '../modules/addresses/ui/action/EditAddress';
import { OrderRecipt } from '../modules/orders/ui/OrderRecipt';
import { ProtectedRoute } from './ProtectedRoute';

export const routes = {
  // Public routes - no authentication required
  mainRoutes: [
    { path: '/', element: <HomePage /> },
    { path: '/search', element: <SearchPage /> },
    { path: '/:id', element: <FoodDetail /> },
    { path: '/notification', element: <Notification /> },
    { path: '/restaurants', element: <RestaurantPage /> },
    { path: '/restaurants/list', element: <PickupSearch /> },
    { path: '/cart', element: <BasketPage /> },
    { path: '/promotions', element: <PromotionPage /> },
    { path: '/promotions/promocode', element: <PromocodePage /> },
    { path: '*', element: <>404</> },
  ],

  // Protected routes - authentication required
  protectedRoutes: [
    { path: '/profile', element: <ProfilePage /> },
    {
      path: '/profile/addresses',
      element: (
        <ProtectedRoute>
          <AddressesPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/profile/about',
      element: (
        <ProtectedRoute>
          <AboutPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/profile/user-info',
      element: (
        <ProtectedRoute>
          <UserInfoPage />
        </ProtectedRoute>
      ),
    },
    { path: '/profile/orders', element: <OrdersPage /> },
    // Без ProtectedRoute: язык меняют и гости, ради этого их незачем гнать
    // на авторизацию.
    { path: '/profile/settings', element: <SettingsPage /> },
    {
      path: '/profile/cards',
      element: (
        <ProtectedRoute>
          <CardPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/profile/orders/:orderId',
      element: (
        <ProtectedRoute>
          <OrderDetailsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/profile/orders/:orderId/receipt',
      element: (
        <ProtectedRoute>
          <OrderRecipt />
        </ProtectedRoute>
      ),
    },
  ],

  // Standalone protected routes
  standaloneProtectedRoutes: [
    { path: '/restaurants/map', element: <PickupMap /> },
    {
      path: '/checkout',
      element: (
        <ProtectedRoute>
          <CheckoutPage />
        </ProtectedRoute>
      ),
    },
    // Public on purpose: useCreateAddress has a guest branch that keeps the
    // address in local storage, and both the home and cart delivery rows send
    // signed-out users here. Wrapping it bounced every guest back to "/".
    { path: '/adding-address', element: <AddingAddress /> },
    {
      path: '/adding-address/:id',
      element: (
        <ProtectedRoute>
          <EditAddress />
        </ProtectedRoute>
      ),
    },
  ],
};
